import classNames from 'classnames'
import PropTypes from 'prop-types'

import s from './ToggleField.module.css'

function ToggleField({
  children,
  className = '',
  toggled = false,
  onChange = () => {},
}) {
  if (!children) return null
  return (
    <button
      type="button"
      className={classNames(className, s.container, { [s.toggled]: toggled })}
      onClick={onChange}
    >
      {children}
    </button>
  )
}

ToggleField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  toggled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default ToggleField
